var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transparency 1",
    clipPath: "url(#clip0_280_558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83459 23.834L0 29.6686V31.2763L2.72359 33.9999H4.33128L10.1659 28.1653V26.5576L7.44235 23.834H5.83459Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5591 20.7173L8.81921 22.4571L11.5428 25.1806L13.2834 23.4401C12.2544 22.6615 11.3423 21.7494 10.5591 20.7173Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.9944 13.1564C22.5419 13.0677 22.9138 12.5519 22.825 12.0044C22.7363 11.4569 22.2205 11.085 21.673 11.1738C21.1255 11.2625 20.7536 11.7783 20.8423 12.3258C20.9311 12.8733 21.4469 13.2452 21.9944 13.1564Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8379 7.36775C18.6357 7.36775 15.7774 10.8091 14.7773 12.1626C15.992 13.9333 19.2163 17.0965 21.8379 16.9565C25.0407 16.9565 27.8997 13.5135 28.899 12.1611C26.5409 8.95173 23.7792 7.31934 21.8379 7.36775ZM21.8379 15.1587C20.1856 15.1587 18.8413 13.8144 18.8413 12.1621C18.8413 10.5098 20.1856 9.1655 21.8379 9.1655C23.4902 9.1655 24.8345 10.5098 24.8345 12.1621C24.8345 13.8144 23.4902 15.1587 21.8379 15.1587Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.8379 0C15.121 0 9.67578 5.44518 9.67578 12.1621C9.67578 18.879 15.121 24.3242 21.8379 24.3242C28.5548 24.3242 34 18.879 34 12.1621C34 5.44518 28.5548 0 21.8379 0ZM21.8379 18.9486C16.3296 18.8387 12.6024 12.4652 12.3781 12.1621C12.6024 11.859 16.3296 5.48549 21.8379 5.37559C27.3461 5.48549 31.0734 11.859 31.2977 12.1621C30.7499 13.0156 27.1131 18.8302 21.8379 18.9486Z",
    fill: "#00FFF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.5ac4de188478e878b044d84361ec2709.svg";
export { ForwardRef as ReactComponent };